import { useEffect, useState } from "react";
import moment from "moment";

import { Page, Container } from "@/ui/Layout/Page";
import { Grid } from "@/ui/Grid";
import { Card } from "@/ui/Card";
import { getCampaigns } from "@/api/campaigns";
import { ButtonTypes, Status } from "@/ui/types";
import { getSessionToken } from "@/api/auth";
import { Link } from "react-router-dom";
import Button from "@/ui/Button";
import { EmptyState } from "@/ui/Layout";
import { Loading } from "@/ui/Layout/Loading";

import { LAUNCH_OS_ICON } from "@/brand";
export const Campaigns = ({ name = "" }) => {
  const [campaignList, setCampaignList] = useState([]);
  const [isLoading, setIsLoading] = useState<boolean>(true);

  // get the campaignList from the server
  const loadCampaigns = async () => {
    const token = getSessionToken();
    const response = await getCampaigns({ token, type: "workflow" });
    if (response) {
      // convert the response to the format that the Card components expect
      const seqs = response
        ?.filter(({ deleted }) => !deleted)
        .map((campaign: any) => {
          return {
            id: campaign.id,
            label: campaign.name,
            caption: `Last Updated: ${moment(campaign.updatedAt).fromNow()}`,
            img: (
              <img
                className="w-[42px] h-[42px] flex-none rounded-full overflow-hidden object-cover"
                src={LAUNCH_OS_ICON}
                alt=""
              />
            ), // funnel.screensnhot
            status: Status.INPROGRESS,
          };
        });

      setCampaignList(seqs);
    }
    setIsLoading(false);
  };

  // load the campaignList when the page loads
  useEffect(() => {
    loadCampaigns();
  }, []);

  return (
    <Page
      topBar={{
        page: [{ label: name }],
        items: (
          <Link to="/launchpad/campaigns" className="justify-end">
            <Button label="+ Create a Campaign" type={ButtonTypes.OUTLINED} />
          </Link>
        ),
      }}
    >
      <Container>
        {isLoading && <Loading type="gallery" />}
        {!isLoading && !Boolean(campaignList.length) && (
          <EmptyState
            title="No Campaigns Yet"
            description="Get started by creating a new campaign."
            showImage={false}
          >
            <Link to="/launchpad/campaigns">
              <Button label="Create a Campaign" type={ButtonTypes.DEFAULT} />
            </Link>
          </EmptyState>
        )}
        {!isLoading && Boolean(campaignList.length) && (
           <Grid className="pb-6">
            {/* Can we change to Gallery View - let's me toggle views */}
            {campaignList.map(
              (
                {
                  id,
                  label,
                  caption,
                  img = "[logo]",
                  status,
                  // sharedWith,
                  taskDetails,
                },
                key
              ) => {
                return (
                  <Card
                    key={key}
                    label={label}
                    caption={caption}
                    image={img}
                    href={`/crm/campaigns/${id}`}
                    status={status}
                    taskDetails={taskDetails}
                  />
                );
              }
            )}
          </Grid>
        )}
      </Container>
    </Page>
  );
};
